import { render, staticRenderFns } from "./LoginResetPasswordForm.vue?vue&type=template&id=52ea72fe"
import script from "./LoginResetPasswordForm.vue?vue&type=script&lang=ts"
export * from "./LoginResetPasswordForm.vue?vue&type=script&lang=ts"
import style0 from "./LoginResetPasswordForm.vue?vue&type=style&index=0&id=52ea72fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports